import { render } from "./UpgradePlanItem.vue?vue&type=template&id=404e1fee"
import script from "./UpgradePlanItem.vue?vue&type=script&lang=js"
export * from "./UpgradePlanItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__